module.exports = __webpack_public_path__ + "img/HZGB03-01-02_3.1945241.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brand_img/HZGB03-01-02_3.png
// module id = N0iX
// module chunks = 0